export default {
  CAR_ACCIDENT: "carAccident",
  FIGHT: "fight",
  ACCIDENT_ON_WORK :"accidentOnWork",
  ACCIDENT_PUBLIC : "accidentPublic",
  OTHER: "other",
}
